import { Entry } from 'contentful'
import { IConfigurableDescriptionList } from 'app/_components/ContentfulPage/ConfigurableDescriptionList/ConfigurableDescriptionList'
import { ITermsAndDescriptions } from 'app/_components/ContentfulPage/ConfigurableDescriptionList/ConfigurableTermsAndDescriptions'
import { parseConfigurableCta } from './parseConfigurableCta'
import { IContentfulConfigurableCtaEntry } from 'types/contentful/configurableCta.types'

export const parseConfigurableDescriptionList = (
  contentfulDescriptionList: Entry<
    Omit<IConfigurableDescriptionList, 'termsAndDescriptionsList' | 'cta'> & {
      termsAndDescriptionsList: Entry<ITermsAndDescriptions>[]
      cta: Entry<IContentfulConfigurableCtaEntry>
    }
  >
): IConfigurableDescriptionList => {
  const configurableDescriptionList = {
    componentKey: 'configurableDescriptionList',
    title: contentfulDescriptionList?.fields?.title,
    titleSize: contentfulDescriptionList?.fields?.titleSize,
    titleColor: contentfulDescriptionList?.fields?.titleColor,
    subTitle: contentfulDescriptionList?.fields?.subTitle,
    subtitleColor: contentfulDescriptionList?.fields?.subtitleColor,
    submenuLabel: contentfulDescriptionList?.fields?.submenuLabel,
    designComponent: contentfulDescriptionList?.fields?.designComponent,
    layout: contentfulDescriptionList?.fields?.layout,
    subtitleSize: contentfulDescriptionList?.fields?.subtitleSize,
    termsAndDescriptionsList:
      contentfulDescriptionList?.fields?.termsAndDescriptionsList?.map(
        (item) => ({
          term: item.fields.term,
          description: item.fields.description,
        })
      ),
    footerNote: contentfulDescriptionList?.fields?.footerNote,
    cta: parseConfigurableCta(contentfulDescriptionList?.fields?.cta),
    backgroundColor: contentfulDescriptionList?.fields?.backgroundColor,
  }

  return configurableDescriptionList
}
